import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/river2/h5/');
export default function F() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
 
    return (
        <div className={`river2_details_F ${css.F_6}`}>
            <div className="innerBox">
                <div className="textBox">
                    <div className="guide">{t('river2.details.sec6_upper_title')}</div>
                    <div className="title">{t(['jp', 'fr', 'es'].includes(locale) ? 'river2.details.sec6_title_h5' : 'river2.details.sec6_title')}</div>
                    <div className="desc">
                        {t.rich('river2.details.sec6_desc', {
                            line1: (child: any) => <span className="green">{child}</span>,
                        })}
                    </div>
                </div>
                <div className="imgBox">
                    <EFPic
                        name={["6.webp", "6.jpg"]}
                        className="fullImgs"
                        // layout="fill"
                        alt={t('river2.details.sec6_title')}
                        aria-label={t('river2.details.sec6_title')}
                    />
                    <p className="year">{t('river2.details.sec6_year')}</p>
                </div>
            </div>
        </div>
    );
}
